// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import Distpicker from 'v-distpicker'
import axios from 'axios2'
import store from './vuex.js'
import Qs from 'qs'
//import MtaH5 from 'mta-h5-analysis'
import i18n from './locales'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.use(VueQuillEditor)

Vue.component('v-distpicker', Distpicker)

Vue.prototype.global = global

Vue.prototype.dingzhiPercentNmae = 'percent_dingzhi'  //百分数显示模式定制platform名称

Vue.prototype.langArrs = {
	zh: '简体中文',
	'zh-TW': '繁體中文',
	'zh-HK': '繁體中文(香港)',
	'zh-TMO': '繁體中文(澳門)',
	en: 'English',
	de: 'Deutsch',
	fr: 'Français',
	ja: '日本語',
	tr: 'Türkçe',
	it: 'Italiano',
	ko: '한국어',
	ru: 'русский язык ',
	vi: 'ViệtName',
	es: 'Español',
	nl: 'Nederlandse taal',
	pt: 'Portuguese',
	id: 'IndonesiaName',
  pl: 'Poland',
  ro: "România",
  bg: "български език",
  ar: "العربية"
}

// 埋点初始化

/*MtaH5.init({
  'sid': '500671447', // 必填，统计用的appid
  'cid': '500671449', // 如果开启自定义事件，此项目为必填，否则不填
  'autoReport': 1, // 是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
  'senseHash': 1, // hash锚点是否进入url统计
  'senseQuery': 1, // url 参数是否进入url统计
  'performanceMonitor': 1, // 是否开启性能监控
  'ignoreParams': [] // 开启url参数上报时，可忽略部分参数拼接上报
})*/
// 页面跳转的时候上报
router.afterEach(() => {
  setTimeout(() => {
    // MtaH5.pgv()
  })
})

// 全局变量
Vue.prototype.axios = axios
axios.interceptors.response.use(
  response => {
    return response
  }, error => {
    if (error.response.status === 401 || error.response.status === 403) {
      Message({
        showClose: true,
        message: window.$vue.$i18n.t('login_error'),
        type: 'error'
      });
      setTimeout(() => {
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        })
      }, 1000)
    } else if (error.response && error.response.status === 500) {
      alert(window.$vue.$i18n.t('server_error'))
    }
    return Promise.reject(error.response.data)
  }
)
axios.defaults.timeout = 30000
axios.interceptors.request.use(
  config => {
    console.log('========'+sessionStorage.userInfo)
    if(sessionStorage.userInfo){
        let userInfo=JSON.parse(sessionStorage.userInfo)
        if(userInfo&&userInfo.user_id){
            config.headers['X-tid'] = userInfo.user_id+'-'+Date.now()
        }
    }
    if (localStorage.language) {
      config.headers['language'] = localStorage.language
    }
	if (localStorage.locale) {
	  config.headers['locale'] = localStorage.locale
	}
    if (localStorage.access_token) {
      config.headers['access_token'] = localStorage.access_token
    }
    let contentType = config.headers['Content-Type']
    if (!contentType) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
      config.data = Qs.stringify(config.data)
      return config
    }


    if (contentType.indexOf('json') > 0) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      config.data = JSON.stringify(config.data)
      return config
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Vue.prototype.MtaH5 = MtaH5
Vue.prototype.formData = function (obj) {
  return obj
}

Vue.prototype.isPercentDz = function(){
  let userConfs = JSON.parse(localStorage.userConfs)
  if(userConfs.platform == this.dingzhiPercentNmae){
    return true
  }
  return false
}

Vue.prototype.changeValue = function (i, i_key){
	if(i > '5'){
    if(this.isPercentDz()){
      let c = {
        dry: '0% - 20%', 
        mid_dry: '21% - 40%', 
        mid_oil: '24% - 60%', 
        mix: '61% - 80%', 
        oil: '81% - 100%',
        baixi: '0% - 20%', 
        ziran: '21% - 40%', 
        xiaomai: '24% - 60%', 
        anchen: '61% - 80%', 
        youhei: '81% - 100%'
      }
      i_key = i_key.str_replace(' ', '')
      return c[i_key]
    }
		return i
	}

  if(this.isPercentDz()){
    let c = ['0% - 20%', '21% - 40%', '24% - 60%', '61% - 80%', '81% - 100%']
    return c[i-1]
  }
	let c = ['Ⅰ', 'Ⅱ', 'Ⅲ', 'Ⅳ', 'Ⅴ']
	if(localStorage.locale == 'ko'){
		return c[i-1]
	}
	return i
}


Vue.prototype.unSetLocalStorage = function() {
  localStorage.now_code = ''
  localStorage.now_active_code = ''
  localStorage.now_shop_desc = ''
  localStorage.code = ''
  localStorage.dg_code = ''
  localStorage.del_goods_id = ''
  localStorage.edit_goods_id = ''
  localStorage.work_code = ''
  localStorage.edit_work_for_data = ''
  localStorage.qr_code = ''
}

//埋点函数
Vue.prototype.setHankMtaH5 = function (param) {
  console.log(param)
  // this.MtaH5.clickStat(param)
}
Vue.prototype.setHankMtaH5LouDou = function (ldname,itemname) {
  let data = {}
  data[itemname] = 'true'
  // this.MtaH5.clickStat(ldname, data)
}

Vue.prototype.getCookie = function (param) {
  let cparam = ''
  if (document.cookie.length > 0) {
    let arr = document.cookie.split('; ')
    for (let i = 0; i < arr.length; i++) {
      let arr2 = arr[i].split('=')
      if (arr2[0] === param) {
        cparam = arr2[1]
      }
    }
    if (cparam.indexOf('%7B') > -1) {
      return decodeURIComponent(cparam)
    }
    return cparam
  }
}

Vue.prototype.setCookie = function (name, value, path, expire) {
  let cookie = name + '=' + escape(value)
  if (expire) {
    let date = new Date()
    date.setSeconds(date.getSeconds() + expire)
    cookie = cookie + ';expires=' + date.toGMTString()
  }
  if (path) {
    cookie = cookie + ';path=' + path
  }
  document.cookie = cookie
}

Vue.prototype.getCart = function () {
  let value = new Array()
  if (localStorage.shopping_cart) {
    let valueStr = localStorage.shopping_cart
    if (valueStr) {
      try {
        value = JSON.parse(valueStr)
      } catch (e) {
        value = new Array()
      }
      if (!(value instanceof Array)) {
        value = new Array()
      }
    }
  }
  return value
}

Vue.prototype.setCart = function (value) {
  localStorage.shopping_cart = JSON.stringify(value)
  store.commit('setCartCount', value.length)
}

Vue.prototype.addToCart = function (good) {
  var value = this.getCart()
  var goods =
  {
    'goods_id': good.id,
    'num': 1,
    'price': good.price
  }

  if (value && value.length > 0) {
    var i = 0
    for (; i < value.length; i++) {
      var item = value[i]
      if (item.goods_id == good.id) {
        item.num++
        goods = item
        value.splice(i, 1)
        break
      }
    }
  }
  value.push(goods)

  this.setCart(value)
}

Vue.prototype.getArrayIndex = function (arrayObj, key, val) {
  for (let i = 0; i < arrayObj.length; i++) {
    if (arrayObj[i][key] === val) {
      return i
    }
  }
  return -1
}

Vue.prototype.DeleteFromCart = function (goodsId) {
  let value = this.getCart()
  console.log(value.length)
  let i = 0
  for (; i < value.length; i++) {
    let item = value[i]
    if (item.goods_id == goodsId) {
      value.splice(i, 1)
      this.setCart(value)
      break
    }
  }
}

Vue.prototype.subFromCart = function (goodsId) {
  var value = this.getCart()

  if (value) {
    var i = 0
    for (; i < value.length; i++) {
      var item = value[i]
      if (item.goods_id == goodsId) {
        item.num--
        if (item.num == 0) {
          value.splice(i)
          i--
        }

        this.setCart(value)
        break
      }
    }
  }
}
Vue.prototype.toUrlParams = function (obj) {
  let res = ''
  if (Object.keys(obj).length > 0) {
    let array = []
    for (let i in obj) {
      array.push(i + '=' + obj[i])
    }
    res = array.join('&')
  }
  return res
}

/// Promise写法  this.axios 要在promise里面
Vue.prototype.httpPost = function (url, data, isJosn = false) {
  console.log(JSON.stringify(data))
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      data: isJosn ? data : this.toUrlParams(data),
      headers: {
        'Content-Type': isJosn ? 'application/json;charset=UTF-8' : 'application/x-www-form-urlencoded'
      }
    }).then((res) => {
      res.data.code === 0 ? resolve(res.data) : reject(res.data.msg)
    }).catch((res) => {
      console.log(res)
      reject(new Error(res))
    })
  })
}

// 粘贴版事件
Vue.prototype.copyToClipboard = function (text) {
  let callback = true

  var textArea = document.createElement("textarea")
  textArea.style.position = 'fixed'
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.width = '2em'
  textArea.style.height = '2em'
  textArea.style.padding = '0'
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'
  textArea.style.background = 'transparent'
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.select()

  try {
    var successful = document.execCommand('copy')
    callback = successful
  } catch (err) {
    callback = false
  }

  document.body.removeChild(textArea)

  return callback
}

Vue.prototype.getConfigType = function () {
  if (!localStorage.configStype) {
    localStorage.configStype = 1
    return 1
  }
  if (localStorage.configStype === 1 || localStorage.configStype === '1') {
    return 1
  }
  return 2
}

Vue.prototype.dengDengYu = function (x,y) {
  if (x === y) {
    return true
  }
  y += ''
  if (x === y) {
    return true
  }
  return false
}

Vue.prototype.openFullScreen = function() {
  const dataLoadIng = this.$loading({
    lock: true,
    text: '',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  setTimeout(() => {
    dataLoadIng.close();
  }, 5000);
  return dataLoadIng;
}
Vue.prototype.getBaseUrl = function (url){
    if(!url){
        url=window.location.href
    }
    let host = url.split('//')[0] + '//';
    host = host + url.split('//')[1].split('/')[0];
    return host;
}
Vue.prototype.resizedwindow = function () {
  (function(doc, win) {
    var docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function() {
        var clientWidth = docEl.clientWidth
        if (!clientWidth) return
        docEl.style.fontSize = (clientWidth / 16) + 'px'
        console.log(clientWidth)
      }
    if (!doc.addEventListener) return
    win.addEventListener(resizeEvt, recalc, false)
    doc.addEventListener('DOMContentLoaded', recalc, false)
  })(document, window)
}

Vue.prototype.dateFormatToLocal = function(datestr) {
  if (!datestr) {
    return ''
  }
  // 创建表示北京时间的日期对象
  var beijingTime = new Date(datestr)
  // 获取当前地区的时区偏移值
  var currentOffset = new Date().getTimezoneOffset()

  console.log('时区偏离：' + currentOffset, parseInt(currentOffset / 60))

  // 计算当前地区时区时间
  var convertedTime = new Date(beijingTime.getTime() - 8 * 60 * 60000 - currentOffset * 60000)
  const year = convertedTime.getFullYear()
  const mon = changeTwoNumber(convertedTime.getMonth() + 1)
  const day = changeTwoNumber(convertedTime.getDate())

  const h = changeTwoNumber(convertedTime.getHours())
  const m = changeTwoNumber(convertedTime.getMinutes())

  function changeTwoNumber(i) {
    if (i < 10) {
      return '0' + i
    }
    return i
  }
  return year + '-' + mon + '-' + day + ' ' + h + ':' + m
}

router.beforeEach((to, from, next) => {
  let auth = to.meta.auth
  let token = ''
  if (document.cookie.length > 0) {
    let arr = document.cookie.split('; ')
    for (let i = 0; i < arr.length; i++) {
      let arr2 = arr[i].split('=')
      if (arr2[0] === 'access_token') {
        token = arr2[1]
      }
    }
  }
  if (auth && token.length === 0) {
    next({ path: '/login' })
  } else {
    next()
  }
})
/* eslint-disable no-new */
window.$vue = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js